import LwtApp from '@monorepo/shared/node_modules/@lwtears/lwt-common-frontend/lib/LwtApp';
import GatedApp from 'components/app/GatedApp';
import './App.css';
import i18n from 'translations';
import ApolloProvider from '@monorepo/shared/src/providers/ApolloProvider';
import { ErrorProvider } from '@monorepo/shared/src/providers/ErrorProvider';
import TelemetryProvider from 'state/providers/StudentTelemetryProvider';

const App = (): React.ReactElement => {
  return (
    <LwtApp i18n={i18n}>
      <ErrorProvider>
        <ApolloProvider>
          <TelemetryProvider>
            <GatedApp />
          </TelemetryProvider>
        </ApolloProvider>
      </ErrorProvider>
    </LwtApp>
  );
};

export default App;
